import React from 'react';
import { ExternalLink } from 'lucide-react';
export default function Footer() {
  return (
    <footer className="bg-white border-t border-slate-200 px-4 sm:px-6 py-4 mt-auto">
      <div className="flex flex-wrap items-center justify-end gap-3 text-xs sm:text-sm text-slate-600">
        <a
          href="https://rugira.ch/security"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 transition-colors duration-200 hover:text-brand-red"
          data-testid="link-security"
        >
          <span>Security</span>
          <ExternalLink className="h-3 w-3" aria-hidden="true" />
        </a>

        <a
          href="https://rugira.ch/pricing"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 transition-colors duration-200 hover:text-brand-red"
          data-testid="link-pricing"
        >
          <span>Pricing</span>
          <ExternalLink className="h-3 w-3" aria-hidden="true" />
        </a>

        <a
          href="https://rugira.ch/samples"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 transition-colors duration-200 hover:text-brand-red"
          data-testid="link-samples"
        >
          <span>Samples</span>
          <ExternalLink className="h-3 w-3" aria-hidden="true" />
        </a>
      </div>
    </footer>
  );
}
